<app-section-header i18n-text text="Address">
    <ng-container buttons *ngIf="showAddressSubtitle">
        <div class="bg-white shadow-lg p-2 flex flex-row gap-2 items-center rounded-full">
            <button
                (click)="addAddress()"
                [disabled]="invoiceAddressExists()"
                class="btn btn-sm btn-primary text-sm px-5 rounded-full flex flex-row items-center gap-2"
            >
                <iota-icon icon="plus" size="1x"></iota-icon>
                <span i18n>Invoice address</span>
            </button>
        </div>
    </ng-container>
</app-section-header>

<app-address
    [showAddressSubtitle]="showAddressSubtitle"
    *ngFor="let address of updatedAddresses"
    [address]="address"
    (save)="saveAddress($event)"
    (delete)="removeAddress($event)"
    (editCancelled)="resetValues()"
></app-address>
